<section class="section-catalog">
    <catalog-header *ngIf="!limitedShopping"></catalog-header>
    <div class="container-fluid">
        <div class="bs3-row">
            <side-navigation *ngIf="!limitedShopping"></side-navigation>
            <div class="product-view-container viewsContainer">
                <category-navigation *ngIf="filterView?.parentCategory && !limitedShopping"></category-navigation>
                <catalog-hero *ngIf="hasHero"></catalog-hero>
                <div class="sort-header" *ngIf="!limitedShopping">
                    <div (click)="sideNavToggle()" class="toggle-side-nav d-block d-md-none"
                         [ngClass]="filterView?.sideNavOpen ? 'active': ''">
                        <span translate="cart.categories"></span>
                        <i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
                    </div>
                    <div class="filter-sort" *ngIf="!!filterView">
                        <label for="sortSelect" translate="cart.catalog.product.sort" class="d-none d-md-inline"></label>
                        <select id="sortSelect" [(ngModel)]="filterView.selectedSort" (ngModelChange)="sortCategory()"
                                class="selectpicker">
                            <option *ngFor="let option of sortOptions; trackBy: trackByFn"
                                    [ngValue]="option">{{ option.display }}
                            </option>
                        </select>
                    </div>
                    <div class="filter-panel grid-view">
                        <div class="view-toggle">
                            <button [attr.aria-label]="'cart.categories.grid.view' |translate" class="btnViewSwitcher"
                                    (click)="viewModeToggle('grid')"
                                    [ngClass]="viewMode === 'grid'? 'viewSelected' : 'viewNotSelected'">
                                <i class="fa-solid fa-grid" aria-hidden="true"></i>
                            </button>
                            <button [attr.aria-label]="'cart.categories.list.view' |translate" class="btnViewSwitcher"
                                    (click)="viewModeToggle('list')"
                                    [ngClass]="viewMode === 'list'? 'viewSelected' : 'viewNotSelected'">
                                <i class="fa-solid fa-list" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="products-wrapper">
                    <div class="banners">
                        <skin-analyzer *ngIf="showSkinAnalyzer && isCelavive else upsellBannerContainer"></skin-analyzer>
                        <ng-template #upsellBannerContainer>
                            <upsell-banner></upsell-banner>
                        </ng-template>
                    </div>
                    <div class="spinner-row" [hidden]="!loadingProducts">
                        <usana-spinner [show]="true" [delay]="100"></usana-spinner>
                    </div>
                    <div class="container" *ngIf="!hasProducts && !loadingProducts">
                        <div class="row-old">
                            <div class="col-12 productMeta">
                                <div class="clearfix">
                                    <h3 class="text-center" translate="cart.catalog.products.missing.title"></h3>
                                </div>
                            </div>
                        </div>
                        <div class="row-old">
                            <div class="col-12 productMeta text-center">
                                <span translate="cart.catalog.products.missing.text"></span>
                            </div>
                        </div>
                    </div>
                    <div class="product-flex-container" [ngClass]="viewMode + '-view'" [hidden]="loadingProducts">

                        <ng-container *ngFor="let pg of (productGroups$ | async); trackBy: trackByFn">

                            <product-card *ngIf="pg.products[pg.firstProductId]"
                                          class="product-card-container"
                                          [ngClass]="viewMode === 'grid'? 'card-grid-view': 'card-list-view'"
                                          (mouseleave)="activeHover = null"
                                          (mouseenter)="activeHover = pg.firstProductId"
                                          [cardClass]="viewMode + '-mode'"
                                          [productGroup]="pg"
                                          [hideStrikeThroughPricing]="true"
                                          [hidePreferredPricing]="true"
                                          [secondaryActionsTemplate]="secondaryActionsTemplate"
                                          [primaryActionsTemplate]="primaryActionsTemplate"></product-card>

                            <ng-template #secondaryActionsTemplate>

                                <div class="product-card-secondary-actions"
                                     *ngIf="(showFbShareables || showUrlShareables) && authenticated">

                                    <addShareList [displaySize]="'small'"
                                                  [addProduct]="pg.products[pg.firstProductId]"
                                                  location="grid"
                                                  [btnClass]="'product-list'"
                                                  *ngIf="displayUrlShareables$(pg) | async">

                                    </addShareList>
                                </div>

                            </ng-template>

                            <ng-template #primaryActionsTemplate>
                                <div class="product-tax" *ngIf="shouldDisplayImportTax && !!pg.vatTaxRate">
                                    <span [translate]="'cart.display.import.tax'" [interpolate]="pg.vatTaxRate"
                                          [key]="'taxrate'"></span>
                                </div>

                                <button #buttonElement class="button button-medium"
                                        [ngClass]="viewMode === 'list'? 'addToCartBtnListView' : ''"
                                        (click)="productSelected(pg, buttonElement)"
                                        *ngIf="!pg.hasVariations && (showAddToCartButton$(pg) | async)">
                                    <span class="hidden-mobile"
                                          translate="cart.product.catalog.gridview.addtocart"></span>
                                    <i class="hidden-desktop fa-solid fa-cart-plus" aria-hidden="true"></i>
                                </button>


                                <button class="button button-medium"
                                        [routerLink]="[PRODUCT_ROUTE, pg.firstUsanaId]"
                                        *ngIf="pg.hasVariations">
                                    <span class="hidden-mobile"
                                          translate="cart.product.catalog.gridview.viewdetails"></span>
                                    <i class="hidden-desktop fa-solid fa-ellipsis" aria-hidden="true"></i>
                                </button>


                                <add-ao-dropdown
                                    *ngIf="!pg.hasVariations "
                                    class="hidden-mobile"
                                    [addProduct]="pg.products[pg.firstProductId]"
                                    btnClass="button button-medium catalog-add-ao {{viewMode}}"
                                    [quantity]="1"
                                    [useUpdatedAoList]="true"
                                    [analyticsName]="'grid'"></add-ao-dropdown>

                            </ng-template>

                        </ng-container>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-product-drawer (openClose)="showDrawer = $event" [productGroup]="activeProductGroup"
                        [showDrawer]="showDrawer"></app-product-drawer>

</section>
